import React from "react";
import { ListActionButtonProps } from "sprint-common-web";

import { AuthorizationWrapper } from "../../../core/security/AuthorizationWrapper";
import { SprintAccessRight } from "../../../core/security/SprintAccessRight";
import { DeliveryBucketItem } from "../listing/DeliveryBucketItem";
import { DisableDeliveryBucketButton } from "./disable/DisableDeliveryBucketButton";
import { EnableDeliveryBucketButton } from "./enable/EnableDeliveryBucketButton";

type ChangeDeliveryBucketButtonProps = ListActionButtonProps<DeliveryBucketItem>;

export const ChangeStateDeliveryBucketButton: React.VFC<ChangeDeliveryBucketButtonProps> = ({
    item,
    itemId
}: ChangeDeliveryBucketButtonProps) => {
    return (
        <AuthorizationWrapper accessRights={[SprintAccessRight.CiAdmin]}>
            {item.isActive && <DisableDeliveryBucketButton itemId={itemId} />}
            {!item.isActive && <EnableDeliveryBucketButton itemId={itemId} />}
        </AuthorizationWrapper>
    );
};
